import React, { useState } from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import { lighten, makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import SearchBar from "material-ui-search-bar";
import DeleteIcon from "@material-ui/icons/Delete";
import { fetchWithToken } from "../../../../apiUtils";

function descendingComparator(a, b, orderBy) {
  if (a[orderBy] === null) {
    return 1;
  } else if (b[orderBy] === null) {
    return -1;
  }
  return a[orderBy].toLowerCase().localeCompare(b[orderBy].toLowerCase());
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

const headCells = [
  { id: "gmid", numeric: false, disablePadding: true },
  { id: "fullName", numeric: true, disablePadding: false },
  { id: "email", numeric: true, disablePadding: false },
];

function EnhancedTableHead(props) {
  const {
    classes,
    order,
    orderBy,
    onRequestSort,
    searchedObj,
    setPage,
    setSearched,
    handleSearch,
    handleCancelSearch,
    searched,
  } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  const handleInput = (searchVal, domain) => {
    setPage(0);
    setSearched({ searched: searchVal, domain: domain });
  };

  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={"center"}
            sortDirection={orderBy === headCell.id ? order : false}
            style={{ fontSize: ".9vw", padding: "5px" }}
          >
            <div
              class="input-group"
              style={{ justifyContent: "center", marginBottom: "12px" }}
            >
              {headCell.id == "gmid" && (
                <SearchBar
                  placeholder="GMID"
                  value={
                    searchedObj.domain === "gmid" ? searchedObj.searched : ""
                  }
                  onChange={(searchVal) => handleInput(searchVal, "gmid")}
                  onCancelSearch={() => setSearched("")}
                  className={classes.searchbar}
                  style={{ width: "80%" }}
                />
              )}
              {headCell.id == "fullName" && (
                <SearchBar
                  placeholder="Name"
                  value={
                    searchedObj.domain === "fullName"
                      ? searchedObj.searched
                      : ""
                  }
                  onChange={(searchVal) => handleInput(searchVal, "fullName")}
                  onCancelSearch={() => setSearched("")}
                  className={classes.searchbar}
                  style={{ width: "80%" }}
                />
              )}
              {headCell.id == "email" && (
                <SearchBar
                  placeholder="Email"
                  value={
                    searchedObj.domain === "email" ? searchedObj.searched : ""
                  }
                  onChange={(searchVal) => handleInput(searchVal, "email")}
                  onCancelSearch={() => setSearched("")}
                  className={classes.searchbar}
                  style={{ width: "80%" }}
                />
              )}

              {headCell.id == "submitDate" && (
                <div style={{ fontSize: "1vw", paddingBottom: "45px" }} />
              )}

              <TableSortLabel
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : "asc"}
                onClick={createSortHandler(headCell.id)}
              >
                {orderBy === headCell.id ? (
                  <span className={classes.visuallyHidden}>
                    {order === "desc"
                      ? "sorted descending"
                      : "sorted ascending"}
                  </span>
                ) : null}
              </TableSortLabel>
            </div>
          </TableCell>
        ))}
        <TableCell
          align="center"
          padding="50px"
          style={{ fontSize: "20px", padding: "5px", width: "150px" }}
        >
          Delete
        </TableCell>
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

const useToolbarStyles = makeStyles((theme) => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  highlight:
    theme.palette.type === "light"
      ? {
          color: theme.palette.secondary.main,
          backgroundColor: lighten(theme.palette.secondary.light, 0.85),
        }
      : {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.secondary.dark,
        },
  title: {
    flex: "1 1 100%",
  },
}));

const EnhancedTableToolbar = (props) => {
  const classes = useToolbarStyles();

  return (
    <Toolbar className={clsx(classes.root)}>
      <Typography
        className={classes.title}
        variant="h6"
        id="tableTitle"
        component="div"
      >
        Users
      </Typography>
    </Toolbar>
  );
};

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  paper: {
    width: "100%",
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: 1,
    margin: -1,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    top: 20,
    width: 1,
  },
}));

const AdminMailingListMailTable = (props) => {
  const { mailList, setDataObj, authObj } = props;
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("firstName");
  const [searchedObj, setSearched] = useState({ searched: "", domain: "" });
  const classes = useStyles();
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const emptyRows =
    rowsPerPage - Math.min(rowsPerPage, mailList.length - page * rowsPerPage);
  var editable = !authObj.roles.includes("admin");

  const handleFilter = () => {
    const filteredRows = mailList.filter((row) => {
      if (searchedObj.domain === "gmid" && row.gmid != null) {
        return row.gmid
          .toString()
          .toLowerCase()
          .includes(searchedObj.searched.toLowerCase());
      }
      if (searchedObj.domain === "fullName" && row.fullName != null) {
        return row.fullName
          .toString()
          .toLowerCase()
          .includes(searchedObj.searched.toLowerCase());
      }
      if (searchedObj.domain === "email" && row.email != null) {
        return row.email
          .toString()
          .toLowerCase()
          .includes(searchedObj.searched.toLowerCase());
      } else return mailList;
    });
    return filteredRows;
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const removeUserHandler = (row) => {
    fetchWithToken(`/api/AdminMailingList/RemoveUser/`, "DELETE", {
      userId: row.userId,
    })
      .then((data) => {
        if (data.ok) {
          setDataObj((prev) => {
            return {
              ...prev,
              mailList: [
                ...prev.mailList.filter((r) => r.userId != row.userId),
              ],
            };
          });
        }
      })
      .then((data) => {
        if (page > 0 && (mailList.length - 1) % rowsPerPage == 0) {
          setPage(page - 1);
        }
      });
  };

  return (
    <>
      <TableContainer>
        <Table
          className={classes.table}
          aria-labelledby="tableTitle"
          size={"medium"}
          aria-label="enhanced table"
        >
          <EnhancedTableHead
            classes={classes}
            order={order}
            orderBy={orderBy}
            onRequestSort={handleRequestSort}
            setSearched={setSearched}
            searchedObj={searchedObj}
            setPage={setPage}
            rowCount={mailList.length}
          />
          <TableBody>
            {stableSort(handleFilter(), getComparator(order, orderBy))
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row, index) => {
                return (
                  <TableRow
                    role="checkbox"
                    tabIndex={-1}
                    key={row.name}
                    style={{
                      height: "60px",
                      background: index % 2 ? "#f8f8f8" : "white",
                    }}
                  >
                    <TableCell align="center" style={{ width: "30%" }}>
                      {row.gmid}
                    </TableCell>
                    <TableCell align="center" style={{ width: "30%" }}>
                      {row.fullName}
                    </TableCell>
                    <TableCell align="left" style={{ width: "30%" }}>
                      {row.email}
                    </TableCell>
                    <TableCell
                      className={classes.smallColumn}
                      lign="center"
                      style={{ width: "10%" }}
                    >
                      <Button
                        variant="contained"
                        size="small"
                        color="secondary"
                        onClick={() => removeUserHandler(row)}
                        disabled={editable}
                      >
                        <DeleteIcon />
                      </Button>
                    </TableCell>
                  </TableRow>
                );
              })}
            {emptyRows > 0 && (
              <TableRow
                style={{
                  height: mailList.length > rowsPerPage ? 65 * emptyRows : 65,
                }}
              >
                <TableCell colSpan={4} />
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 50, 100]}
        component="div"
        count={mailList.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </>
  );
};

export default AdminMailingListMailTable;
